// Generated by KlangScriptProcessor, DO NOT EDIT
@file:Suppress("UNCHECKED_CAST", "UNUSED_PARAMETER", "UnusedImport")

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.KlangScriptLibrary
import io.peekandpoke.klang.script.annotations.KlangScope
import io.peekandpoke.klang.script.ast.CallInfo
import io.peekandpoke.klang.script.builder.*
import io.peekandpoke.klang.script.runtime.*
import io.peekandpoke.klang.script.types.*

import io.peekandpoke.klang.audio_bridge.AdsrBuilder
import io.peekandpoke.klang.audio_bridge.BandFilterBuilder
import io.peekandpoke.klang.audio_bridge.EqBuilder
import io.peekandpoke.klang.audio_bridge.FilterBuilder
import io.peekandpoke.klang.audio_bridge.FmBuilder
import io.peekandpoke.klang.audio_bridge.IgnitorBandsBuilder
import io.peekandpoke.klang.audio_bridge.IgnitorDsl
import io.peekandpoke.klang.audio_bridge.KatalystBandsBuilder
import io.peekandpoke.klang.audio_bridge.KatalystBodyBuilder
import io.peekandpoke.klang.audio_bridge.KatalystBuilder
import io.peekandpoke.klang.audio_bridge.KatalystDelayBuilder
import io.peekandpoke.klang.audio_bridge.KatalystDsl
import io.peekandpoke.klang.audio_bridge.KatalystEqBuilder
import io.peekandpoke.klang.audio_bridge.KatalystKnobDsl
import io.peekandpoke.klang.audio_bridge.KatalystPhaserBuilder
import io.peekandpoke.klang.audio_bridge.KatalystRampBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSawBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSineBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSquareBuilder
import io.peekandpoke.klang.audio_bridge.KatalystTriBuilder
import io.peekandpoke.klang.audio_bridge.KatalystVowelBuilder
import io.peekandpoke.klang.audio_bridge.ModAdsrBuilder
import io.peekandpoke.klang.audio_bridge.OscImpulseBuilder
import io.peekandpoke.klang.audio_bridge.OscPluckBuilder
import io.peekandpoke.klang.audio_bridge.OscPulzeBuilder
import io.peekandpoke.klang.audio_bridge.OscRampBuilder
import io.peekandpoke.klang.audio_bridge.OscSawBuilder
import io.peekandpoke.klang.audio_bridge.OscSineBuilder
import io.peekandpoke.klang.audio_bridge.OscSquareBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperPluckBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperRampBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSawBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSineBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSquareBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperTriBuilder
import io.peekandpoke.klang.audio_bridge.OscTriBuilder
import io.peekandpoke.klang.audio_bridge.OscZampBuilder
import io.peekandpoke.klang.audio_bridge.OscZawtoothBuilder
import io.peekandpoke.klang.audio_bridge.PhaserBuilder
import io.peekandpoke.klang.audio_bridge.PitchEnvelopeBuilder
import io.peekandpoke.klang.audio_bridge.ShimmerBuilder
import io.peekandpoke.klang.audio_bridge.TremoloBuilder
import io.peekandpoke.klang.audio_bridge.VibratoBuilder
import io.peekandpoke.klang.common.SourceLocation
import io.peekandpoke.klang.script.runtime.ArrayValue
import io.peekandpoke.klang.script.runtime.BooleanValue
import io.peekandpoke.klang.script.runtime.NumberValue
import io.peekandpoke.klang.script.runtime.RuntimeValue
import io.peekandpoke.klang.script.runtime.StringValue
import io.peekandpoke.klang.script.stdlib.E
import io.peekandpoke.klang.script.stdlib.Ign
import io.peekandpoke.klang.script.stdlib.IgnitorDslLike
import io.peekandpoke.klang.script.stdlib.Kat
import io.peekandpoke.klang.script.stdlib.KlangScriptArrayExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptBooleanExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitor
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCoarseSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCrushSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorDistortSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorFmSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorTremoloSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorVibratoSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalyst
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystBodySlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystCompressorSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDelaySlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDuckSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystGainSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystPhaserSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystReverbSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystVowelSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptMath
import io.peekandpoke.klang.script.stdlib.KlangScriptNumberExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptObjectUtility
import io.peekandpoke.klang.script.stdlib.KlangScriptStringExtensions
import io.peekandpoke.klang.script.stdlib.PI
import io.peekandpoke.klang.script.stdlib.scriptAbs
import io.peekandpoke.klang.script.stdlib.scriptAdd
import io.peekandpoke.klang.script.stdlib.scriptAdsr
import io.peekandpoke.klang.script.stdlib.scriptAnalog
import io.peekandpoke.klang.script.stdlib.scriptAnalogSpread
import io.peekandpoke.klang.script.stdlib.scriptBand
import io.peekandpoke.klang.script.stdlib.scriptBands
import io.peekandpoke.klang.script.stdlib.scriptBlend
import io.peekandpoke.klang.script.stdlib.scriptBody
import io.peekandpoke.klang.script.stdlib.scriptBrightness
import io.peekandpoke.klang.script.stdlib.scriptCap
import io.peekandpoke.klang.script.stdlib.scriptCenterJitter
import io.peekandpoke.klang.script.stdlib.scriptClassic
import io.peekandpoke.klang.script.stdlib.scriptCompressor
import io.peekandpoke.klang.script.stdlib.scriptCurves
import io.peekandpoke.klang.script.stdlib.scriptCut
import io.peekandpoke.klang.script.stdlib.scriptDeclick
import io.peekandpoke.klang.script.stdlib.scriptDelay
import io.peekandpoke.klang.script.stdlib.scriptDistort
import io.peekandpoke.klang.script.stdlib.scriptDiv
import io.peekandpoke.klang.script.stdlib.scriptDuck
import io.peekandpoke.klang.script.stdlib.scriptDuty
import io.peekandpoke.klang.script.stdlib.scriptEnv
import io.peekandpoke.klang.script.stdlib.scriptEq
import io.peekandpoke.klang.script.stdlib.scriptFallFlank
import io.peekandpoke.klang.script.stdlib.scriptFeedback
import io.peekandpoke.klang.script.stdlib.scriptFlankSamples
import io.peekandpoke.klang.script.stdlib.scriptFloor
import io.peekandpoke.klang.script.stdlib.scriptFundamental
import io.peekandpoke.klang.script.stdlib.scriptGain
import io.peekandpoke.klang.script.stdlib.scriptGainJitter
import io.peekandpoke.klang.script.stdlib.scriptHarmonics
import io.peekandpoke.klang.script.stdlib.scriptHumanize
import io.peekandpoke.klang.script.stdlib.scriptLimiter
import io.peekandpoke.klang.script.stdlib.scriptMax
import io.peekandpoke.klang.script.stdlib.scriptMin
import io.peekandpoke.klang.script.stdlib.scriptMinus
import io.peekandpoke.klang.script.stdlib.scriptMul
import io.peekandpoke.klang.script.stdlib.scriptNeg
import io.peekandpoke.klang.script.stdlib.scriptNegate
import io.peekandpoke.klang.script.stdlib.scriptOctaves
import io.peekandpoke.klang.script.stdlib.scriptOversampleAtLeast
import io.peekandpoke.klang.script.stdlib.scriptOversampleBy
import io.peekandpoke.klang.script.stdlib.scriptParallel
import io.peekandpoke.klang.script.stdlib.scriptPartial
import io.peekandpoke.klang.script.stdlib.scriptPasses
import io.peekandpoke.klang.script.stdlib.scriptPhase
import io.peekandpoke.klang.script.stdlib.scriptPhasePool
import io.peekandpoke.klang.script.stdlib.scriptPhaser
import io.peekandpoke.klang.script.stdlib.scriptPickPosition
import io.peekandpoke.klang.script.stdlib.scriptPlus
import io.peekandpoke.klang.script.stdlib.scriptPow
import io.peekandpoke.klang.script.stdlib.scriptPower
import io.peekandpoke.klang.script.stdlib.scriptRange
import io.peekandpoke.klang.script.stdlib.scriptResetSamples
import io.peekandpoke.klang.script.stdlib.scriptReverb
import io.peekandpoke.klang.script.stdlib.scriptRiseFlank
import io.peekandpoke.klang.script.stdlib.scriptSerial
import io.peekandpoke.klang.script.stdlib.scriptShape
import io.peekandpoke.klang.script.stdlib.scriptShapeMax
import io.peekandpoke.klang.script.stdlib.scriptSideAtten
import io.peekandpoke.klang.script.stdlib.scriptSpread
import io.peekandpoke.klang.script.stdlib.scriptSpreadPower
import io.peekandpoke.klang.script.stdlib.scriptStiffness
import io.peekandpoke.klang.script.stdlib.scriptSub
import io.peekandpoke.klang.script.stdlib.scriptSuboctaves
import io.peekandpoke.klang.script.stdlib.scriptTap
import io.peekandpoke.klang.script.stdlib.scriptTimes
import io.peekandpoke.klang.script.stdlib.scriptVoices
import io.peekandpoke.klang.script.stdlib.scriptVowel

internal fun KlangScriptExtensionBuilder.registerStdlibKlangScriptIgnitorExtensionsChunk0() {

    // @TypeExtensions(IgnitorDsl::class) on KlangScriptIgnitorExtensions
    registerType<IgnitorDsl> {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "lowpass",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class),
                ParamSpec(name = "q", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.707) }),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "lowpass", args = args, expected = 1, location = loc)
            val freq = convertArgToKotlin(fn = "lowpass", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.lowpass(
                    typedReceiver,
                    freq = freq,
                    q = if (args.size > 1) convertArgToKotlin(fn = "lowpass", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 0.707,
                    configure = optArg(args, 2, Function1::class, loc) as ((FilterBuilder) -> FilterBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "highpass",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class),
                ParamSpec(name = "q", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.707) }),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "highpass", args = args, expected = 1, location = loc)
            val freq = convertArgToKotlin(fn = "highpass", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.highpass(
                    typedReceiver,
                    freq = freq,
                    q = if (args.size > 1) convertArgToKotlin(fn = "highpass", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 0.707,
                    configure = optArg(args, 2, Function1::class, loc) as ((FilterBuilder) -> FilterBuilder)?,
                )
            )
        }
        registerMethod<Any, IgnitorDsl>("onepole", listOf(
                ParamSpec(name = "freq", kotlinType = Any::class)
            )) { freq -> KlangScriptIgnitorExtensions.onepole(this, freq = freq) }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "bandpass",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class),
                ParamSpec(name = "q", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.707) }),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "bandpass", args = args, expected = 1, location = loc)
            val freq = convertArgToKotlin(fn = "bandpass", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.bandpass(
                    typedReceiver,
                    freq = freq,
                    q = if (args.size > 1) convertArgToKotlin(fn = "bandpass", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 0.707,
                    configure = optArg(args, 2, Function1::class, loc) as ((BandFilterBuilder) -> BandFilterBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "optimizer",
            paramSpecs = listOf(
                ParamSpec(name = "on", kotlinType = Int::class, isOptional = true, default = { wrapAsRuntimeValue(1) })
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "optimizer", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.optimizer(
                    typedReceiver,
                    on = if (args.size > 0) convertArgToKotlin(fn = "optimizer", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int else 1,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "eq",
            paramSpecs = listOf(
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "eq", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.eq(
                    typedReceiver,
                    configure = optArg(args, 0, Function1::class, loc) as ((EqBuilder) -> EqBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "notch",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class),
                ParamSpec(name = "q", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.707) }),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "notch", args = args, expected = 1, location = loc)
            val freq = convertArgToKotlin(fn = "notch", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.notch(
                    typedReceiver,
                    freq = freq,
                    q = if (args.size > 1) convertArgToKotlin(fn = "notch", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 0.707,
                    configure = optArg(args, 2, Function1::class, loc) as ((BandFilterBuilder) -> BandFilterBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "adsr",
            paramSpecs = listOf(
                ParamSpec(name = "attack", kotlinType = Any::class),
                ParamSpec(name = "decay", kotlinType = Any::class),
                ParamSpec(name = "sustain", kotlinType = Any::class),
                ParamSpec(name = "release", kotlinType = Any::class),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "adsr", args = args, expected = 4, location = loc)
            val attack = convertArgToKotlin(fn = "adsr", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
            val decay = convertArgToKotlin(fn = "adsr", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
            val sustain = convertArgToKotlin(fn = "adsr", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any
            val release = convertArgToKotlin(fn = "adsr", args = args, index = 3, cls = Any::class, nullable = false, loc = loc) as Any
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.adsr(
                    typedReceiver,
                    attack = attack,
                    decay = decay,
                    sustain = sustain,
                    release = release,
                    configure = optArg(args, 4, Function1::class, loc) as ((AdsrBuilder) -> AdsrBuilder)?,
                )
            )
        }
        registerMethod<IgnitorDsl>("classic", emptyList()) { KlangScriptIgnitorExtensions.classic(this) }
        registerMethod<Any, IgnitorDsl>("drive", listOf(
                ParamSpec(name = "amount", kotlinType = Any::class)
            )) { amount -> KlangScriptIgnitorExtensions.drive(this, amount = amount) }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "shape",
            paramSpecs = listOf(
                ParamSpec(name = "shape", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue("soft") })
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "shape", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.shape(
                    typedReceiver,
                    shape = if (args.size > 0) convertArgToKotlin(fn = "shape", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else "soft",
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "distort",
            paramSpecs = listOf(
                ParamSpec(name = "amount", kotlinType = Any::class),
                ParamSpec(name = "shape", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue("soft") })
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "distort", args = args, expected = 1, location = loc)
            val amount = convertArgToKotlin(fn = "distort", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.distort(
                    typedReceiver,
                    amount = amount,
                    shape = if (args.size > 1) convertArgToKotlin(fn = "distort", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else "soft",
                )
            )
        }
        registerMethod<Any, IgnitorDsl>("crush", listOf(
                ParamSpec(name = "bits", kotlinType = Any::class)
            )) { bits -> KlangScriptIgnitorExtensions.crush(this, bits = bits) }
        registerMethod<Any, IgnitorDsl>("coarse", listOf(
                ParamSpec(name = "factor", kotlinType = Any::class)
            )) { factor -> KlangScriptIgnitorExtensions.coarse(this, factor = factor) }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "phaser",
            paramSpecs = listOf(
                ParamSpec(name = "wet", kotlinType = Any::class),
                ParamSpec(name = "rate", kotlinType = Any::class),
                ParamSpec(name = "center", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1000.0) }),
                ParamSpec(name = "sweep", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1000.0) }),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "phaser", args = args, expected = 2, location = loc)
            val wet = convertArgToKotlin(fn = "phaser", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
            val rate = convertArgToKotlin(fn = "phaser", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.phaser(
                    typedReceiver,
                    wet = wet,
                    rate = rate,
                    center = if (args.size > 2) convertArgToKotlin(fn = "phaser", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 1000.0,
                    sweep = if (args.size > 3) convertArgToKotlin(fn = "phaser", args = args, index = 3, cls = Any::class, nullable = false, loc = loc) as Any else 1000.0,
                    configure = optArg(args, 4, Function1::class, loc) as ((PhaserBuilder) -> PhaserBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "tremolo",
            paramSpecs = listOf(
                ParamSpec(name = "rate", kotlinType = Any::class),
                ParamSpec(name = "depth", kotlinType = Any::class),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "tremolo", args = args, expected = 2, location = loc)
            val rate = convertArgToKotlin(fn = "tremolo", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
            val depth = convertArgToKotlin(fn = "tremolo", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.tremolo(
                    typedReceiver,
                    rate = rate,
                    depth = depth,
                    configure = optArg(args, 2, Function1::class, loc) as ((TremoloBuilder) -> TremoloBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "shimmer",
            paramSpecs = listOf(
                ParamSpec(name = "wet", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.5) }),
                ParamSpec(name = "feedback", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.5) }),
                ParamSpec(name = "tone", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(4000.0) }),
                ParamSpec(name = "pitches", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "shimmer", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.shimmer(
                    typedReceiver,
                    wet = if (args.size > 0) convertArgToKotlin(fn = "shimmer", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else 0.5,
                    feedback = if (args.size > 1) convertArgToKotlin(fn = "shimmer", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 0.5,
                    tone = if (args.size > 2) convertArgToKotlin(fn = "shimmer", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 4000.0,
                    pitches = optArg(args, 3, Any::class, loc),
                    configure = optArg(args, 4, Function1::class, loc) as ((ShimmerBuilder) -> ShimmerBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "fm",
            paramSpecs = listOf(
                ParamSpec(name = "modulator", kotlinType = Any::class),
                ParamSpec(name = "ratio", kotlinType = Any::class),
                ParamSpec(name = "depth", kotlinType = Any::class),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "fm", args = args, expected = 3, location = loc)
            val modulator = convertArgToKotlin(fn = "fm", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
            val ratio = convertArgToKotlin(fn = "fm", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
            val depth = convertArgToKotlin(fn = "fm", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.fm(
                    typedReceiver,
                    modulator = modulator,
                    ratio = ratio,
                    depth = depth,
                    configure = optArg(args, 3, Function1::class, loc) as ((FmBuilder) -> FmBuilder)?,
                )
            )
        }
        registerMethod<Any, IgnitorDsl>("detune", listOf(
                ParamSpec(name = "semitones", kotlinType = Any::class)
            )) { semitones -> KlangScriptIgnitorExtensions.detune(this, semitones = semitones) }
        registerMethod<IgnitorDsl>("octaveUp", emptyList()) { KlangScriptIgnitorExtensions.octaveUp(this) }
        registerMethod<IgnitorDsl>("octaveDown", emptyList()) { KlangScriptIgnitorExtensions.octaveDown(this) }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "vibrato",
            paramSpecs = listOf(
                ParamSpec(name = "rate", kotlinType = Any::class),
                ParamSpec(name = "semitones", kotlinType = Any::class),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "vibrato", args = args, expected = 2, location = loc)
            val rate = convertArgToKotlin(fn = "vibrato", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
            val semitones = convertArgToKotlin(fn = "vibrato", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.vibrato(
                    typedReceiver,
                    rate = rate,
                    semitones = semitones,
                    configure = optArg(args, 2, Function1::class, loc) as ((VibratoBuilder) -> VibratoBuilder)?,
                )
            )
        }
        registerMethod<Any, IgnitorDsl>("accelerate", listOf(
                ParamSpec(name = "semitones", kotlinType = Any::class)
            )) { semitones -> KlangScriptIgnitorExtensions.accelerate(this, semitones = semitones) }
        registerMethod<Any, IgnitorDsl>("pitchMod", listOf(
                ParamSpec(name = "mod", kotlinType = Any::class)
            )) { mod -> KlangScriptIgnitorExtensions.pitchMod(this, mod = mod) }
        registerMethod<Any, IgnitorDsl>("pitchModSemitones", listOf(
                ParamSpec(name = "mod", kotlinType = Any::class)
            )) { mod -> KlangScriptIgnitorExtensions.pitchModSemitones(this, mod = mod) }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "pitchEnvelope",
            paramSpecs = listOf(
                ParamSpec(name = "semitones", kotlinType = Any::class),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "pitchEnvelope", args = args, expected = 1, location = loc)
            val semitones = convertArgToKotlin(fn = "pitchEnvelope", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.pitchEnvelope(
                    typedReceiver,
                    semitones = semitones,
                    configure = optArg(args, 1, Function1::class, loc) as ((PitchEnvelopeBuilder) -> PitchEnvelopeBuilder)?,
                )
            )
        }
        registerVarargMethod<((IgnitorDsl) -> IgnitorDsl), IgnitorDsl>("serial") { args -> KlangScriptIgnitorExtensions.scriptSerial(this, *args.toTypedArray()) }
        registerVarargMethod<((IgnitorDsl) -> IgnitorDsl), IgnitorDsl>("parallel") { args -> KlangScriptIgnitorExtensions.scriptParallel(this, *args.toTypedArray()) }
        registerMethod<Any, ((IgnitorDsl) -> IgnitorDsl), IgnitorDsl>("blend", listOf(
                ParamSpec(name = "wet", kotlinType = Any::class),
                ParamSpec(name = "branch", kotlinType = Function1::class)
            )) { wet, branch -> KlangScriptIgnitorExtensions.scriptBlend(this, wet = wet, branch = branch) }
        registerMethod<Any, ((IgnitorDsl) -> IgnitorDsl), IgnitorDsl>("oversampleBy", listOf(
                ParamSpec(name = "factor", kotlinType = Any::class),
                ParamSpec(name = "body", kotlinType = Function1::class)
            )) { factor, body -> KlangScriptIgnitorExtensions.scriptOversampleBy(this, factor = factor, body = body) }
        registerMethod<Any, ((IgnitorDsl) -> IgnitorDsl), IgnitorDsl>("oversampleAtLeast", listOf(
                ParamSpec(name = "factor", kotlinType = Any::class),
                ParamSpec(name = "body", kotlinType = Function1::class)
            )) { factor, body -> KlangScriptIgnitorExtensions.scriptOversampleAtLeast(this, factor = factor, body = body) }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "bands",
            paramSpecs = listOf(
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            @Suppress("UNCHECKED_CAST")
            val typedReceiver = receiver as IgnitorDsl
            checkArgsSize(fn = "bands", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitorExtensions.scriptBands(
                    typedReceiver,
                    configure = optArg(args, 0, Function1::class, loc) as ((IgnitorBandsBuilder) -> IgnitorBandsBuilder)?,
                )
            )
        }
        registerMethod<Any, IgnitorDsl>("plus", listOf(
                ParamSpec(name = "other", kotlinType = Any::class)
            )) { other -> KlangScriptIgnitorExtensions.scriptPlus(this, other = other) }
        registerMethod<Any, IgnitorDsl>("add", listOf(
                ParamSpec(name = "other", kotlinType = Any::class)
            )) { other -> KlangScriptIgnitorExtensions.scriptAdd(this, other = other) }
        registerMethod<Any, IgnitorDsl>("minus", listOf(
                ParamSpec(name = "other", kotlinType = Any::class)
            )) { other -> KlangScriptIgnitorExtensions.scriptMinus(this, other = other) }
        registerMethod<Any, IgnitorDsl>("sub", listOf(
                ParamSpec(name = "other", kotlinType = Any::class)
            )) { other -> KlangScriptIgnitorExtensions.scriptSub(this, other = other) }
        registerMethod<Any, IgnitorDsl>("times", listOf(
                ParamSpec(name = "other", kotlinType = Any::class)
            )) { other -> KlangScriptIgnitorExtensions.scriptTimes(this, other = other) }
        registerMethod<Any, IgnitorDsl>("mul", listOf(
                ParamSpec(name = "other", kotlinType = Any::class)
            )) { other -> KlangScriptIgnitorExtensions.scriptMul(this, other = other) }
        registerMethod<IgnitorDsl>("pregain", emptyList()) { KlangScriptIgnitorExtensions.scriptPregain(this) }
        registerMethod<Any, IgnitorDsl>("div", listOf(
                ParamSpec(name = "other", kotlinType = Any::class)
            )) { other -> KlangScriptIgnitorExtensions.scriptDiv(this, other = other) }
        registerMethod<IgnitorDsl>("neg", emptyList()) { KlangScriptIgnitorExtensions.scriptNeg(this) }
        registerMethod<IgnitorDsl>("negate", emptyList()) { KlangScriptIgnitorExtensions.scriptNegate(this) }
        registerMethod<IgnitorDsl>("abs", emptyList()) { KlangScriptIgnitorExtensions.scriptAbs(this) }
        registerMethod<Any, IgnitorDsl>("pow", listOf(
                ParamSpec(name = "exp", kotlinType = Any::class)
            )) { exp -> KlangScriptIgnitorExtensions.scriptPow(this, exp = exp) }
        registerMethod<Any, IgnitorDsl>("power", listOf(
                ParamSpec(name = "exp", kotlinType = Any::class)
            )) { exp -> KlangScriptIgnitorExtensions.scriptPower(this, exp = exp) }
        registerMethod<Any, IgnitorDsl>("min", listOf(
                ParamSpec(name = "other", kotlinType = Any::class)
            )) { other -> KlangScriptIgnitorExtensions.scriptMin(this, other = other) }
        registerMethod<Any, IgnitorDsl>("max", listOf(
                ParamSpec(name = "other", kotlinType = Any::class)
            )) { other -> KlangScriptIgnitorExtensions.scriptMax(this, other = other) }
        registerMethod<Any, Any, IgnitorDsl>("clamp", listOf(
                ParamSpec(name = "lo", kotlinType = Any::class),
                ParamSpec(name = "hi", kotlinType = Any::class)
            )) { lo, hi -> KlangScriptIgnitorExtensions.scriptClamp(this, lo = lo, hi = hi) }
        registerMethod<IgnitorDsl>("exp", emptyList()) { KlangScriptIgnitorExtensions.scriptExp(this) }
        registerMethod<IgnitorDsl>("log", emptyList()) { KlangScriptIgnitorExtensions.scriptLog(this) }
        registerMethod<IgnitorDsl>("sqrt", emptyList()) { KlangScriptIgnitorExtensions.scriptSqrt(this) }
        registerMethod<IgnitorDsl>("sign", emptyList()) { KlangScriptIgnitorExtensions.scriptSign(this) }
        registerMethod<IgnitorDsl>("tanh", emptyList()) { KlangScriptIgnitorExtensions.scriptTanh(this) }
        registerMethod<Any, Any, IgnitorDsl>("lerp", listOf(
                ParamSpec(name = "other", kotlinType = Any::class),
                ParamSpec(name = "t", kotlinType = Any::class)
            )) { other, t -> KlangScriptIgnitorExtensions.scriptLerp(this, other = other, t = t) }
        registerMethod<Any, Any, IgnitorDsl>("mix", listOf(
                ParamSpec(name = "other", kotlinType = Any::class),
                ParamSpec(name = "t", kotlinType = Any::class)
            )) { other, t -> KlangScriptIgnitorExtensions.scriptMix(this, other = other, t = t) }
        registerMethod<Any, Any, IgnitorDsl>("range", listOf(
                ParamSpec(name = "from", kotlinType = Any::class),
                ParamSpec(name = "to", kotlinType = Any::class)
            )) { from, to -> KlangScriptIgnitorExtensions.scriptRange(this, from = from, to = to) }
        registerMethod<Any, Any, IgnitorDsl>("rangex", listOf(
                ParamSpec(name = "from", kotlinType = Any::class),
                ParamSpec(name = "to", kotlinType = Any::class)
            )) { from, to -> KlangScriptIgnitorExtensions.scriptRangex(this, from = from, to = to) }
        registerMethod<IgnitorDsl>("floor", emptyList()) { KlangScriptIgnitorExtensions.scriptFloor(this) }
        registerMethod<IgnitorDsl>("ceil", emptyList()) { KlangScriptIgnitorExtensions.scriptCeil(this) }
        registerMethod<IgnitorDsl>("round", emptyList()) { KlangScriptIgnitorExtensions.scriptRound(this) }
        registerMethod<IgnitorDsl>("frac", emptyList()) { KlangScriptIgnitorExtensions.scriptFrac(this) }
        registerMethod<Any, IgnitorDsl>("mod", listOf(
                ParamSpec(name = "other", kotlinType = Any::class)
            )) { other -> KlangScriptIgnitorExtensions.scriptMod(this, other = other) }
        registerMethod<Any, IgnitorDsl>("rem", listOf(
                ParamSpec(name = "other", kotlinType = Any::class)
            )) { other -> KlangScriptIgnitorExtensions.scriptRem(this, other = other) }
        registerMethod<IgnitorDsl>("recip", emptyList()) { KlangScriptIgnitorExtensions.scriptRecip(this) }
        registerMethod<IgnitorDsl>("reciprocal", emptyList()) { KlangScriptIgnitorExtensions.scriptReciprocal(this) }
        registerMethod<IgnitorDsl>("sq", emptyList()) { KlangScriptIgnitorExtensions.scriptSq(this) }
        registerMethod<Any, Any, IgnitorDsl>("select", listOf(
                ParamSpec(name = "whenTrue", kotlinType = Any::class),
                ParamSpec(name = "whenFalse", kotlinType = Any::class)
            )) { whenTrue, whenFalse -> KlangScriptIgnitorExtensions.scriptSelect(this, whenTrue = whenTrue, whenFalse = whenFalse) }
    }
}

